import { useState, useRef, useEffect } from 'react';

// Create a single audio instance that will be shared across all uses of the hook
let sharedAudioInstance = null;

export const useAudio = () => {
    const [audioMuted, setAudioMuted] = useState(() => {
        // Initialize state from localStorage on mount
        if (typeof window !== 'undefined') {
            const isUnmuted = localStorage.getItem('audioUnmuted') === 'true';
            return !isUnmuted; // Convert to muted state (true = muted, false = unmuted)
        }
        return true; // Default to muted
    });
    const hasInitialized = useRef(false);

    useEffect(() => {
        // Create or get the shared audio instance
        if (!sharedAudioInstance) {
            sharedAudioInstance = new Audio('/assets/audio/bg_loop.mp3');
            sharedAudioInstance.loop = true;
            sharedAudioInstance.muted = audioMuted;
        }

        // Cleanup function
        return () => {
            // Don't destroy the shared instance on unmount
            // Only pause it if we're unmounting the last component using it
            if (sharedAudioInstance) {
                sharedAudioInstance.pause();
            }
        };
    }, []);

    // Handle mute state changes
    useEffect(() => {
        if (sharedAudioInstance) {
            sharedAudioInstance.muted = audioMuted;
            
            // Only attempt to play after user has interacted
            if (!audioMuted && hasInitialized.current) {
                sharedAudioInstance.play().catch(err => {
                    console.warn('Could not play audio after unmuting:', err);
                });
            } else {
                sharedAudioInstance.pause();
            }
            
            // Update localStorage
            if (typeof window !== 'undefined') {
                if (!audioMuted) {
                    localStorage.setItem('audioUnmuted', 'true');
                } else {
                    localStorage.removeItem('audioUnmuted');
                }
            }
        }
    }, [audioMuted]);

    // Create toggleAudio function
    const toggleAudio = () => {
        hasInitialized.current = true; // Mark that user has interacted
        setAudioMuted(prev => !prev);
    };

    return { audioMuted, toggleAudio };
}; 